<template>
    <div ref="form" class="form">
        <div class="main_form">
            <form @submit.prevent="send">
                <div
                    v-if="!hideTitle"
                    class="form_title"
                    :class="{ second_font: isModal }"
                >
                    הגשת מועמדות
                </div>
                <div
                    style="display: flex; flex-wrap: wrap; width: 100%; justify-content: space-between;"
                >
                    <div
                        v-for="(question, index) in questions"
                        :key="question.id"
                        class="question"
                        :style="{
                            flex: `0 0 ${question.width}%`,
                            'max-width': `${question.width}%`
                        }"
                    >
                        <question
                            :question="question"
                            :validation="$v.questions.$each[index].answer"
                            @input="onInput($event, index)"
                        />
                    </div>
                </div>
                <hr />
                <div class="btn_wrapper text_right">
                    <button class="btn btn_green" type="button" @click="send">
                        העלאה
                    </button>
                </div>

                <recaptcha-message />
            </form>
        </div>
    </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import { mapActions } from 'vuex';
import { email } from 'vuelidate/lib/validators';
import Question from '@/components/forms/Question';
import recaptchaMixin from '@/mixins/recaptcha.mixin.js';

export default {
    validations: {
        questions: {
            $each: {
                answer: {
                    required(val, { isRequired }) {
                        if (!isRequired) {
                            return true;
                        }

                        return !!val;
                    },
                    isFormatValid(val, { regex: pattern }) {
                        if (!pattern) {
                            return true;
                        }

                        const regex = new RegExp(pattern);

                        return regex.test(val);
                    },
                    email(val, { type }) {
                        if (type === 'email') {
                            return email(val);
                        }

                        return true;
                    },
                    correctQuantity(val, { settings }) {
                        if (
                            !settings ||
                            (!settings.minOptions && !settings.maxOptions)
                        ) {
                            return true;
                        }

                        const {
                            minOptions: min = 0,
                            maxOptions: max = 0
                        } = settings;

                        return !(
                            !Array.isArray(val) ||
                            (min && val.length < min) ||
                            (max && val.length > max)
                        );
                    }
                }
            }
        }
    },

    components: {
        Question
    },

    mixins: [recaptchaMixin],

    props: {
        id: {
            type: String,
            required: true
        },
        formQuestions: {
            type: Array,
            required: false,
            default: null
        },
        isModal: {
            type: Boolean,
            required: false,
            default: false
        },
        hideTitle: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            results: null,
            error: '',
            questions: []
        };
    },

    async created() {
        if (this.formQuestions) {
            this.questions = cloneDeep(this.formQuestions);

            return;
        }

        try {
            const { questions } = await this.getForm(this.id);

            this.questions = questions;
        } catch (err) {
            console.error(err);

            this.$toasterError();
        }
    },

    methods: {
        ...mapActions({
            sendSubmission: 'forms/sendSubmission',
            getForm: 'forms/show'
        }),

        async send() {
            this.error = null;

            this.$v.$touch();

            if (this.$v.$invalid) {
                await this.$nextTick();

                this.scrollToError();

                return;
            }

            const submission = new FormData();

            for (const { answer, label } of this.questions) {
                if (answer) {
                    submission.append(label, answer);
                }
            }

            submission.append('source', this.$route.path);

            try {
                const recaptchaToken = await this.$recaptcha.execute(
                    'submission'
                );

                submission.append('_token', recaptchaToken);

                this.results = await this.sendSubmission({
                    id: this.id,
                    submission
                });

                this.$emit('send');
            } catch (err) {
                const { response } = err;

                if (!response) {
                    console.error(err);
                    this.error = 'משהו השתבש';

                    return;
                }

                const { data, status } = response;

                if (status === 401) {
                    this.error = 'Only available for logged in users';

                    return;
                }

                if (data) {
                    this.error = data;

                    return;
                }

                this.error = 'משהו השתבש';

                console.error(err);

                this.$sentry.captureException(err);
            }
        },

        onInput(answer, index) {
            const question = this.questions[index];

            this.questions.splice(index, 1, { ...question, answer });
        },

        scrollToError() {
            const [element] = this.$refs.form.getElementsByClassName(
                'is-invalid'
            );

            if (!element) {
                return;
            }

            if (this.isModal) {
                const applyModal = document.getElementById('apply_modal');

                if (!applyModal) {
                    return;
                }

                applyModal.scrollTo({
                    top: element.offsetTop,
                    behavior: 'smooth'
                });
            }

            window.scrollTo({
                top: element.offsetTop - 150,
                behavior: 'smooth'
            });
        }
    }
};
</script>
